import { defineCustomElement } from 'vue'
import AssistenzaWiperWC from './AssistenzaWiperWC.ce.vue'

const AssistenzaWiperWCElement = defineCustomElement(AssistenzaWiperWC)


customElements.define('assistenza-wiper', AssistenzaWiperWCElement)
